/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================
   MIN QUANTITY ENFORCEMENT — tag min-qty-{n}
   Forces minimum quantity on product page and validates cart.
   ============================================================ */
(function() {
  'use strict';

  // Parse min-qty tag from product page body class or meta
  function getMinQtyFromTags() {
    // The product tags are available via the data attribute we inject in the Liquid
    var el = document.querySelector('[data-min-qty]');
    if (el) return parseInt(el.getAttribute('data-min-qty'), 10) || 0;
    return 0;
  }

  // === PRODUCT PAGE: enforce min on quantity input ===
  function enforceProductMinQty() {
    var minQty = getMinQtyFromTags();
    if (minQty <= 1) return;

    var qtyInput = document.querySelector('.quantity-selector--product input[type="number"]');
    if (!qtyInput) return;

    qtyInput.setAttribute('min', minQty);
    qtyInput.setAttribute('step', '1');
    if (parseInt(qtyInput.value, 10) < minQty) {
      qtyInput.value = minQty;
    }

    // Show notice near quantity
    var wrapper = qtyInput.closest('.product-form__quantity-with-rules');
    if (wrapper && !wrapper.querySelector('.min-qty-notice')) {
      var notice = document.createElement('p');
      notice.className = 'min-qty-notice';
      notice.style.cssText = 'color:#856404;font-size:13px;margin-top:6px;font-weight:500;';
      notice.textContent = 'Minimum ' + (minQty * 100) + ' jetons (' + minQty + ' lots de 100)';
      wrapper.appendChild(notice);
    }

    // Intercept decrease button
    qtyInput.addEventListener('change', function() {
      if (parseInt(this.value, 10) < minQty) {
        this.value = minQty;
      }
    });
  }

  // === ADD TO CART: validate before submission ===
  function interceptAddToCart() {
    var minQty = getMinQtyFromTags();
    if (minQty <= 1) return;

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.matches || !form.matches('.product-form')) return;

      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      var qty = parseInt(qtyInput.value, 10);
      if (qty < minQty) {
        e.preventDefault();
        e.stopPropagation();
        alert('Commande minimum : ' + (minQty * 100) + ' jetons (' + minQty + ' lots de 100).\nVeuillez sélectionner au moins ' + minQty + ' lots.');
        qtyInput.value = minQty;
        qtyInput.focus();
        return false;
      }
    }, true);
  }

  // === CART PAGE: validate quantities and warn ===
  function validateCart() {
    // Cart validation runs on /cart page
    if (window.location.pathname !== '/cart') return;

    var checkoutBtn = document.querySelector('button[name="checkout"]');
    if (!checkoutBtn) return;

    checkoutBtn.closest('form').addEventListener('submit', function(e) {
      // Fetch cart data to check min quantities
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var violations = [];
          cart.items.forEach(function(item) {
            // Check if product has min-qty tag
            // We check by looking at the product handle — items with "jeton" and "lot-de-100" in handle
            if (item.properties && item.properties._min_qty) {
              var min = parseInt(item.properties._min_qty, 10);
              if (item.quantity < min) {
                violations.push(item.title + ' : minimum ' + min + ' lots');
              }
            }
          });
          if (violations.length > 0) {
            alert('Quantité insuffisante :\n' + violations.join('\n'));
          }
        });
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enforceProductMinQty();
      interceptAddToCart();
      validateCart();
    });
  } else {
    enforceProductMinQty();
    interceptAddToCart();
    validateCart();
  }
})();


/* ============================================================
   FIX SMART FILTER — pagination AJAX (2026-03-29)
   Smart Filter applique spf-filter-loading sur le body pendant
   le chargement. Quand le thème recharge via AJAX (changement
   de page), Smart Filter ne retire pas toujours cette classe,
   laissant les produits invisibles (opacity:0).
   Ce fix force le retrait de la classe après chaque reload.
   ============================================================ */
(function() {
  'use strict';

  function clearSmartFilterLoading() {
    // Retirer la classe de chargement Smart Filter
    document.body.classList.remove('spf-filter-loading');
    // Forcer la visibilité des produits
    var products = document.querySelectorAll('#gf-products > *, [data-globo-filter-items] > *');
    products.forEach(function(el) {
      el.style.visibility = '';
      el.style.opacity = '';
    });
  }

  // Au chargement natif thème (changement page/filtre)
  document.addEventListener('theme:loading:end', function() {
    // Délai court pour laisser le DOM se mettre à jour
    setTimeout(clearSmartFilterLoading, 100);
    setTimeout(clearSmartFilterLoading, 500);
  });

  // Aussi au chargement initial de la page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(clearSmartFilterLoading, 800);
    });
  } else {
    setTimeout(clearSmartFilterLoading, 800);
  }
})();


/* ELA Globo filter fallback 2026-06-17 */
(function () {
  var SUPPORTED_FILTERS = { '814130': true, '814131': true, '814134': true };
  var activeRequest = null;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function getFilterState() {
    var state = {};
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      if (key.indexOf('gf_') !== 0) return;
      var id = key.slice(3);
      if (!SUPPORTED_FILTERS[id]) return;
      state[id] = String(value || '').split('+').map(decodeURIComponent).filter(Boolean);
    });
    return state;
  }

  function setFilterState(state) {
    var url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.indexOf('gf_') === 0 || key === 'page') url.searchParams.delete(key);
    });
    Object.keys(state).forEach(function (id) {
      if (state[id] && state[id].length) url.searchParams.set('gf_' + id, state[id].map(encodeURIComponent).join('+'));
    });
    window.history.pushState({ elaFilterFallback: true }, '', url.toString());
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function formatPrice(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    return number.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function productPrice(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var prices = variants.map(function (variant) { return Number(variant.price); }).filter(Number.isFinite);
    if (!prices.length && product.price != null) prices.push(Number(product.price));
    if (!prices.length) return '';
    return formatPrice(Math.min.apply(Math, prices));
  }

  function productImage(product) {
    if (product.image && product.image.src) return product.image.src;
    if (Array.isArray(product.images) && product.images[0] && product.images[0].src) return product.images[0].src;
    return '';
  }

  function apiUrlFromPreload(state) {
    var preload = document.getElementById('gf-filter-preload');
    if (!preload || !preload.href) return null;
    var url = new URL(preload.href);
    url.searchParams.set('event', Object.keys(state).length ? 'all' : 'init');
    url.searchParams.delete('page');
    Object.keys(state).forEach(function (id) {
      state[id].forEach(function (value) {
        url.searchParams.append('filter[' + id + '][]', value);
      });
    });
    return url.toString();
  }

  function renderFilterBlock(filter, state) {
    if (!SUPPORTED_FILTERS[String(filter.id)] || !Array.isArray(filter.values) || !filter.values.length) return '';
    var id = String(filter.id);
    var selected = state[id] || [];
    var limit = id === '814130' || id === '814131' ? 80 : 20;
    var values = filter.values.slice(0, limit);
    return '<section class="ela-gf-block" data-filter-id="' + escapeHtml(id) + '">' +
      '<button type="button" class="ela-gf-title" aria-expanded="true">' + escapeHtml(filter.label) + '</button>' +
      '<div class="ela-gf-options">' +
      values.map(function (item) {
        var checked = selected.indexOf(String(item.value)) !== -1;
        return '<label class="ela-gf-option">' +
          '<input type="checkbox" value="' + escapeHtml(item.value) + '"' + (checked ? ' checked' : '') + '>' +
          '<span>' + escapeHtml(item.label) + '</span>' +
          '<small>' + escapeHtml(item.count) + '</small>' +
        '</label>';
      }).join('') +
      '</div>' +
    '</section>';
  }

  function renderFilters(data, state) {
    var contents = document.querySelector('#gf-tree .gf-filter-contents');
    var tree = document.getElementById('gf-tree');
    if (!contents || !tree || !Array.isArray(data.filters)) return;
    contents.innerHTML =
      '<div class="ela-gf-refine">' +
        '<button type="button" class="ela-gf-clear">Tout effacer</button>' +
      '</div>' +
      data.filters.map(function (filter) { return renderFilterBlock(filter, state); }).join('');
    tree.classList.add('ela-gf-fallback-ready');
    tree.style.height = 'auto';
    document.documentElement.classList.remove('spf-filter-loading');
  }

  function renderProducts(data) {
    var grid = document.getElementById('gf-products');
    if (!grid || !Array.isArray(data.products)) return;
    if (!data.products.length) {
      grid.innerHTML = '<p class="ela-gf-empty">Aucun produit ne correspond aux filtres selectionnes.</p>';
      return;
    }
    grid.innerHTML = data.products.map(function (product) {
      var image = productImage(product);
      var price = productPrice(product);
      return '<article class="ela-gf-card">' +
        '<a class="ela-gf-card-image" href="/products/' + escapeHtml(product.handle) + '">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="ela-gf-card-body">' +
          '<a class="ela-gf-card-title" href="/products/' + escapeHtml(product.handle) + '">' + escapeHtml(product.title) + '</a>' +
          (product.vendor ? '<div class="ela-gf-card-vendor">' + escapeHtml(product.vendor) + '</div>' : '') +
          (price ? '<div class="ela-gf-card-price">' + escapeHtml(price) + ' HT</div>' : '') +
        '</div>' +
      '</article>';
    }).join('');
    var summary = document.querySelector('.gf-summary');
    if (summary && data.pagination && data.pagination.total != null) {
      summary.textContent = data.pagination.total + ' produits';
    }
  }

  async function loadAndRender(state, updateProducts) {
    var url = apiUrlFromPreload(state);
    if (!url) return;
    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();
    var response = await fetch(url, { signal: activeRequest.signal, cache: 'default' });
    if (!response.ok) throw new Error('Globo fallback HTTP ' + response.status);
    var data = await response.json();
    renderFilters(data, state);
    if (updateProducts) renderProducts(data);
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var title = event.target.closest('.ela-gf-title');
      if (title) {
        var block = title.closest('.ela-gf-block');
        var expanded = title.getAttribute('aria-expanded') !== 'false';
        title.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (block) block.classList.toggle('is-collapsed', expanded);
      }
      if (event.target.closest('.ela-gf-clear')) {
        var clearState = {};
        setFilterState(clearState);
        loadAndRender(clearState, true).catch(function (error) { console.warn(error); });
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('.ela-gf-option input[type="checkbox"]');
      if (!input) return;
      var block = input.closest('.ela-gf-block');
      if (!block) return;
      var id = block.getAttribute('data-filter-id');
      var state = getFilterState();
      var values = state[id] || [];
      if (input.checked && values.indexOf(input.value) === -1) values.push(input.value);
      if (!input.checked) values = values.filter(function (value) { return value !== input.value; });
      if (values.length) state[id] = values;
      else delete state[id];
      setFilterState(state);
      loadAndRender(state, true).catch(function (error) { console.warn(error); });
    });

    window.addEventListener('popstate', function () {
      loadAndRender(getFilterState(), true).catch(function (error) { console.warn(error); });
    });
  }

  onReady(function () {
    window.setTimeout(function () {
      var contents = document.querySelector('#gf-tree .gf-filter-contents');
      if (!contents || contents.children.length) return;
      bindEvents();
      loadAndRender(getFilterState(), Object.keys(getFilterState()).length > 0).catch(function (error) { console.warn(error); });
    }, 2200);
  });
})();
